import {Alert, Button, Form, Modal, Table} from "react-bootstrap";
import {useEffect, useState} from "react";
import {useAuth} from "../../providers/authprovider";

export default function EditPrevilagesModal(props){

    const {privilege} = props;
    const {users} = useAuth();
    const worker = props.worker;
    const [privilages, setPrivilages] = useState(undefined);

    useEffect(()=>{
        if(privilages!== undefined)
            return;

        users.getPrevilages(worker, response =>{
            if(response.success)
                setPrivilages(response.content)
        });

    })

   const [alert, setAlert] = useState({
        show:false,
        content:"",
        variant:"",
        title:""
    })

    const hideAlert = ()=>{
        setAlert({
            show:false,
            content:"",
            variant:"",
            title:""
        })
    }

    const handleSubmit = (event)=>{
        event.preventDefault();
        event.stopPropagation();

        if(!privilege.edit)
            return;

        users.grantPrivilages({privilages: privilages, userId: worker.id}, ({success, error, content})=>{

            if(success === true)
                return props.onHide();

            setAlert({
                show:true,
                content:error,
                variant:"danger",
                title:"Błąd"
            })
        })
    }

    const setPrivilageView = (privilage, checked)=>{
        privilage.view = checked;
        if(!checked)
            privilage.edit = false;

        setPrivilages([...privilages]);
    }

    const setPrivilageEdit = (privilage, checked)=>{
        if(checked)
            privilage.view = true;

        privilage.edit = checked;

        setPrivilages([...privilages]);
    }

    return (
        <Modal
            show={true}
            onHide={props.onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            {
                privilages &&
                <Form onSubmit={handleSubmit} >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Edycja uprawnień - {worker.name}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Alert show={alert.show} variant={alert.variant} onClose={hideAlert} dismissible>
                            <p>
                                {alert.content}
                            </p>
                        </Alert>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Nazwa</th>
                                    <th>Podgląd</th>
                                    <th>Edycja</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                privilages?.map(privilage=>
                                    <tr key={privilage.privilage}>
                                        <td>{privilage.name !== null ? privilage.name : privilage.privilage}</td>
                                        <td>
                                            <Form.Check
                                                inline
                                                type={'checkbox'}
                                                checked={privilage.view}
                                                onChange={(e)=>{
                                                    const checked = e.target.checked;
                                                    setPrivilageView(privilage, checked)
                                                }}
                                                id={`privilage-${privilage.privilage}-view`}
                                            />
                                        </td>
                                        <td>
                                            <Form.Check
                                                inline
                                                type={'checkbox'}
                                                checked={privilage.edit}
                                                onChange={(e)=>{
                                                    const checked = e.target.checked;
                                                    setPrivilageEdit(privilage, checked)
                                                }}
                                                id={`privilage-${privilage.privilage}-edit`}
                                            />
                                        </td>
                                    </tr>
                                )
                            }
                            </tbody>
                        </Table>

                    </Modal.Body>
                    <Modal.Footer>
                        <Alert show={true} variant={"info"}  >

                            <b>Uwaga.</b> Użytkownikowi zostaną nadane nowe prawa dopiero bo jego ponownym zalogowaniu się.

                        </Alert>
                        {
                            privilege.edit ===true ?
                                <Button type={"submit"}>Zapisz</Button>
                            :
                                <Button type={"button"} onClick={()=>props.onHide()}>Zamknij</Button>
                        }

                    </Modal.Footer>
                </Form>
            }

        </Modal>
    )
}